import { useCallback, useState } from 'react';

const KEY = 'agents.panelSection.';

function read(id: string, fallback: boolean): boolean {
  try {
    const stored = window.localStorage.getItem(KEY + id);
    if (stored === '1') return true;
    if (stored === '0') return false;
  } catch {
    // Storage can be unavailable (private windows); the default holds.
  }
  return fallback;
}

/**
 * Whether a panel section is open, remembered per section in localStorage
 * (wrapped in try and catch; without storage the default holds).
 */
export function usePanelSectionOpen(
  id: string,
  defaultOpen: boolean
): [boolean, (open: boolean) => void] {
  const [open, setOpenState] = useState(() => read(id, defaultOpen));
  const setOpen = useCallback(
    (next: boolean) => {
      setOpenState(next);
      try {
        window.localStorage.setItem(KEY + id, next ? '1' : '0');
      } catch {
        // Not remembered, still toggled.
      }
    },
    [id]
  );
  return [open, setOpen];
}
